import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { setPageMeta } from "../seo/setPageMeta";

export default function Resources() {

  useEffect(() => {
    setPageMeta({
      title: "Recovery Resources | Celebrate Recovery Independence KY",
      description:
        "Explore helpful resources for your recovery journey including Celebrate Recovery materials, participant guides, and crisis support information.",
      canonical: "https://www.crindependenceky.com/resources",
    });
  }, []);

  return (
    <section>
      <h2 className="page-title">Resources</h2>
      <p className="page-intro">
        Helpful tools and materials for your recovery journey.
      </p>

      <div className="grid-2">
        <div className="card">
          <h3>Recommended Materials</h3>
          <ul className="list">
            <li>Celebrate Recovery Bible</li>
            <li>Celebrate Recovery Participant’s Guides</li>
            <li>Daily devotional materials</li>
            <li>Church support ministries and discipleship resources</li>
            <li>
              <Link to="/recovery-journey" className="resource-link">Aletheia: Recovery Journey</Link> —
              a free 12-step devotional, read online or download the PDF
            </li>
          </ul>
        </div>

        <div className="card">
          <h3>Need Immediate Help?</h3>
          <p>
            This website is not a crisis response service. If you are in danger
            or in an urgent crisis, contact emergency services or an appropriate
            crisis hotline immediately.
          </p>
          <p>
            Call or text the <strong>Suicide and Crisis Lifeline:</strong>{" "}
            <a href="tel:988" className="crisis-link">988</a>
            {" "}or{" "}
            <a href="tel:18002738255" className="crisis-link">1-800-273-8255</a>
          </p>
        </div>
      </div>
    </section>
  );
}